const BULLET_PATTERN = /^\s*[-*\u2022]\s+(.+)$/;
const NUMBER_PATTERN = /^\s*\d+[.)]\s+(.+)$/;
const LIST_PREFIX_PATTERN = /^\s*(?:[-*\u2022]\s+|\d+[.)]\s+)/;

export function stripDescriptionListPrefix(line) {
  return String(line || "").replace(LIST_PREFIX_PATTERN, "").trim();
}

export function formatDescriptionLines(value, type = "plain") {
  const lines = String(value || "").replace(/\r/g, "").split("\n");
  let number = 0;

  return lines
    .map((line) => {
      if (!line.trim()) return "";
      const copy = stripDescriptionListPrefix(line);
      if (type === "bullet") return `\u2022 ${copy}`;
      if (type === "number") {
        number += 1;
        return `${number}. ${copy}`;
      }
      return copy;
    })
    .join("\n");
}

export function parseProductDescription(value) {
  const lines = String(value || "").replace(/\r/g, "").split("\n");
  const blocks = [];
  let paragraph = [];
  let list = null;

  const flushParagraph = () => {
    if (!paragraph.length) return;
    blocks.push({ type: "paragraph", text: paragraph.join(" ") });
    paragraph = [];
  };

  const flushList = () => {
    if (!list) return;
    blocks.push(list);
    list = null;
  };

  lines.forEach((rawLine) => {
    const line = rawLine.trim();
    if (!line) {
      flushParagraph();
      flushList();
      return;
    }

    const bullet = line.match(BULLET_PATTERN);
    const numbered = line.match(NUMBER_PATTERN);
    const listType = bullet ? "bullet" : numbered ? "number" : null;

    if (!listType) {
      flushList();
      paragraph.push(line);
      return;
    }

    flushParagraph();
    if (!list || list.type !== listType) {
      flushList();
      list = { type: listType, items: [] };
    }
    list.items.push((bullet || numbered)[1].trim());
  });

  flushParagraph();
  flushList();
  return blocks;
}
